import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Filter } from 'typings/filters'
import { FilterSet } from '../saved'

type SelectedFilters = Filter[]

const initialState: SelectedFilters = []

const selectedFiltersSlice = createSlice({
  name: 'selectedFilters',
  initialState,
  reducers: {
    selectFilter(state, action: PayloadAction<Filter>) {
      state.push(action.payload)
    },
    deselectFilter(state, action: PayloadAction<Filter>) {
      return state.filter(
        ({ variable_id, answer_code }) =>
          !(
            variable_id === action.payload.variable_id && answer_code === action.payload.answer_code
          )
      )
    },
    selectFilters(state, action: PayloadAction<Filter[]>) {
      return action.payload
    },
    clearVariableFilters(state, action: PayloadAction<number>) {
      return state.filter(({ variable_id }) => variable_id !== action.payload)
    },
    clearAllFilters(state) {
      return initialState
    },
    replaceVariableFilters(
      state,
      action: PayloadAction<{ filters: Filter[]; variableId: number }>
    ) {
      return state
        .filter(({ variable_id }) => variable_id !== action.payload.variableId)
        .concat(action.payload.filters)
    },

    selectImportedFilters(state, action: PayloadAction<FilterSet[]>) {
      const filterSetToApply = action.payload?.find((filter) => filter.isApplied)

      if (filterSetToApply) {
        return Object.values(filterSetToApply.filters).flat()
      }

      return state
    },
  },
})

export const {
  selectFilter,
  deselectFilter,
  selectFilters,
  clearVariableFilters,
  clearAllFilters,
  replaceVariableFilters,
  selectImportedFilters,
} = selectedFiltersSlice.actions

export default selectedFiltersSlice.reducer
